import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { Logger } from "@iloq/shared";
import { Event } from "@iloq/shared";

export default class EventsApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  getEvents(countryCode: string, languageCode: string): Promise<Event[]> {
    Logger.debug("Getting events");

    if (!countryCode) {
      const msg = `countryCode is needed to fetch events (was ${JSON.stringify(countryCode)})`;
      Logger.error(msg);
      return Promise.reject(msg);
    }
    if (!languageCode) {
      const msg = `languageCode is needed to fetch events (was ${JSON.stringify(languageCode)})`;
      Logger.error(msg);
      return Promise.reject(msg);
    }

    const options: AxiosRequestConfig = {
      method: "get",
      url: `/api/v1/events/event?countryCode=${countryCode}&languageCode=${languageCode}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("EventsApi.getEvents failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("EventsApi.getEvents result:", result);
        // Convert JSON-serialized date strings to Date objects
        result.data.forEach((event: Event) => {
          event.startTime = new Date(event.startTime);
          event.endTime = new Date(event.endTime);
          event.enrollmentOpenTime = new Date(event.enrollmentOpenTime);
          event.enrollmentDeadline = new Date(event.enrollmentDeadline);
        });
        return result.data;
      });
  }
}
